export const burgerMenuBlurredBackground = 200;
export const burgerMenuDrawer = 201;

export const navigationBarBreadcrumbs = 300;
export const navigationBar = 301;

export const safeAreaBlocker = 9999;
